import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'antd';

import { EPSystemControlPaymentPlanCard, EPSystemTierPaymentPlanCard } from '@/comp/common/EPTierPaymentPlanCard';
import { useStores } from '@/hooks/use-stores';

import { OfferingPageContainer, ResponsiveContainer } from './styled';

const OfferingPage = () => {
  const { stationStore } = useStores();
  const { t } = useTranslation();

  useEffect(() => {
    stationStore.getTierOffering();
  }, [stationStore.currentStation.id]);

  const onSystemViewRequestTier = () =>
    stationStore.updateRequestTier({
      emailRequestTypeOfInterestedPackage: 'KNOW - SYSTEM',
      emailRequestButtonClicked: 'Offering Page KNOW - SYSTEM payment plan button',
      emailRequestWhichScreen: 'Offering Page',
    });

  const onSystemControlRequestTier = () =>
    stationStore.updateRequestTier({
      emailRequestTypeOfInterestedPackage: 'System Control',
      emailRequestButtonClicked: 'Offering Page System Control payment plan button',
      emailRequestWhichScreen: 'Offering Page',
    });

  const tabItems = [
    {
      label: t('ecoplantOffering'),
      key: 'ecoplant-offering',
      children: (
        <>
          <ResponsiveContainer>
            <EPSystemTierPaymentPlanCard
              onRequestTier={onSystemViewRequestTier}
              className="system-view-payment-plan-card"
              fromOfferingPage
            />
            <EPSystemControlPaymentPlanCard
              onRequestTier={onSystemControlRequestTier}
              className="payment-plan-card"
              fromOfferingPage
            />
          </ResponsiveContainer>
        </>
      ),
    },
    {
      label: t('addOns'),
      key: 'add-ons',
      children: <></>,
      disabled: true,
    },
  ];

  return (
    <OfferingPageContainer>
      <Tabs
        animated={{
          inkBar: true,
          tabPane: false,
        }}
        items={tabItems}
        destroyInactiveTabPane
        moreIcon={false}
      />
    </OfferingPageContainer>
  );
};

export default OfferingPage;
